/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface CompanyMetroSchema {
  metro: string;
  headcount?: number | null;
  growth_rate_12_month?: number | null;
}
